import { Button, Header } from '@kanda-libs/ks-design-library';

interface ViewComponentProps {
  /**
   * Function to close modal
   */
  onClick: () => unknown;
}

const ViewComponent = ({ onClick }: ViewComponentProps) => (
  <Header.Base
    className="text-style-f-em text-neutral-700"
    options={[
      <Button.Icon
        id="job-modal-header-close"
        key="close"
        onClick={onClick}
        icon="close"
      />,
    ]}
  />
);

ViewComponent.displayName = 'JobButton-JobModal-Header-view';

ViewComponent.defaultProps = {};

export default ViewComponent;
